"use client";
import { useState } from "react";
import { trackEvent } from "~/connectors/analytics.connector";
import { AnalyticsEvents } from "~/connectors/analyticsEvents";
import VoucherLaunchOfferDialog from "./VoucherLaunchOfferDialog";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "../Link";

export default function FooterVoucherOffer() {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClick = () => {
    trackEvent(AnalyticsEvents.VOUCHER_REQUEST_TOPBAR_CLICKED);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          mt: 3,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
        }}
      >
        <Typography variant="body2" sx={{ color: "text.secondary", flex: 1 }}>
          🎁 Primul cântecel personalizat are <strong>-70% reducere!</strong> <Link
            href="#"
            onClick={handleClick}
            effect="underline-on-hover"
            sx={{ whiteSpace: "nowrap", flexShrink: 0, mr: 0.5 }}
          >
            Vezi oferta ➜
          </Link>
        </Typography>

      </Box>
      <VoucherLaunchOfferDialog open={dialogOpen} onClose={handleDialogClose} />
    </>
  );
}
